import {
  setClearGraphData,
  setSelectedAccount,
} from "../../../../redux/actions/dashboard/Tab1";
import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPaneIndex } from "../../../../redux/constants";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { setCheckedAccounts } from "../../../../redux/actions/scheduleReport/scheduleReport";
import { setSharedAccount } from "../../../../redux/actions/share/Share";
const { Option } = Select;
const AccountList = ({ createWorkSpace, dashboard, type }) => {
  const sharedAccount = useSelector((state) => state.Share.sharedAccount);
  const dispatch = useDispatch();
  const [brandDrop, setBrandDrop] = useState("");
  const [visible, setVisible] = useState(false);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandVal = brands;
  const panes = useSelector((state) => state?.Tab1?.panes);
  //const footerValue = useSelector((state) => state.Section.footerValue);

  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const authParams = useSelector((state) => state.Authentication.authParams);

  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const accounts = useSelector(
    (state) => state?.ApiCall?.account_list?.data?.result
  );
  let index = getPaneIndex(panes, activeKey);
  const handleOnSelectChange = (e, value) => {
    const selectedAccount = accounts.find(
      (account) => account.display_name === e
    );
    let updatedSelectedAccount = [selectedAccount];
    handleDone(updatedSelectedAccount);
  };

  // to set a default value to sharedaccount while share-modal
  if (
    panes?.[index]?.selected_account_list?.length > 0 &&
    (!sharedAccount || !sharedAccount?.length > 0)
  ) {
    let defaultSharedAccount = panes?.[index]?.selected_account_list?.[0];
    dispatch(setSharedAccount([defaultSharedAccount]));
  }

  useEffect(() => {
    resetState();
  }, [type, accounts]);

  const resetState = () => {
    if (panes[index]?.selected_account_list) {
    } else {
      let updatedSelectedAccount = [accounts[0]];
      handleDone(updatedSelectedAccount);
    }
  };

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };
  const controlNavbar = () => {
    if (window.scrollY > 0) {
      handleVisibleChange(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, []);

  const handleOnSelectClick = (e) => {
    setBrandDrop(e?.type);
  };

  const handleDone = (value) => {
    // type based
    if (type === "share-modal") {
      dispatch(setSharedAccount(value));
    }
    if (type === "global_dashboard") {
      let index = getPaneIndex(panes, activeKey);
      dispatch(setSelectedAccount(value, index, panes));
      dispatch(setClearGraphData(index, panes, "global_brands"));
      dispatch(setSharedAccount(value));
      dispatch(setCheckedAccounts([]));
    }

    setVisible(value);
  };
  return (
    <Select
      showSearch={brandDrop === "mouseenter" ? true : false}
      bordered={false}
      style={{ width: "100%" }}
      defaultValue={
        graphConditionConfig?.selected_account_list?.[0]?.display_name
      }
      placeholder="Search Account"
      onChange={(e) => handleOnSelectChange(e, brandVal)}
      onMouseEnter={(e) => handleOnSelectClick(e)}
      onMouseLeave={(e) => handleOnSelectClick(e)}
      value={
        type === "global_dashboard"
          ? panes[index]?.selected_account_list?.[0]?.display_name
          : type === "share-modal"
          ? sharedAccount?.[0]?.display_name
          : panes[index]?.selected_account_list?.[0]?.display_name
      }
      title={null}
      className="border-radius-4 AccountCategory__dropdown--popup"
      suffixIcon={
        <img
          src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
          alt="arrow"
          className="accordionArrow"
          style={{
            transform: `rotate("180deg")`,
          }}
        />
      }
      dropdownClassName={
        authParams?.theme_type === "1"
          ? "darkTheme brandsdropdown"
          : "lightTheme brandsdropdown"
      }
    >
      {accounts &&
        accounts?.map((el, i) => {
          return (
            <Option
              value={el?.display_name}
              key={el?.category_id}
              label={el?.display_name}
              title={el?.display_name}
              className="AccountCategory__dropdown--option"
            >
              <div className="d-flex align-items-center">
                {el?.display_name?.length > 17
                  ? el?.display_name?.substr(0, 17) + " ..."
                  : el?.display_name}
              </div>
            </Option>
          );
        })}
    </Select>
  );
};

export default AccountList;
